import { render, staticRenderFns } from "./SavedSearchesList.vue?vue&type=template&id=c43919ac&scoped=true"
import script from "./SavedSearchesList.vue?vue&type=script&lang=js"
export * from "./SavedSearchesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43919ac",
  null
  
)

export default component.exports